import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { closeDialogs, Dialog } from '../../../base/dialog';
import { demoteRequest } from '../../../visitors/actions';
/**
 * Dialog to confirm a remote participant demote action.
 *
 * @returns {JSX.Element}
 */
export default function DemoteToVisitorDialog({ participantID }) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const handleSubmit = useCallback(() => {
        // console.log('dialog',participantID);
        dispatch(demoteRequest(participantID));
        dispatch(closeDialogs);
    }, [dispatch, participantID]);
    return (React.createElement(Dialog, { okKey: t('dialog.confirm'), onSubmit: handleSubmit, titleKey: 'Move to visitor' },
        React.createElement("div", null, "Are you sure you want to move this participant to visitor?")));
}
